module.exports = __webpack_public_path__ + "img/pop-up-window.970c70a0.png";